// extracted by css-extract-rspack-plugin
module.exports =  {"root":"TableScrollingContainer__root___yqsCD"};